export { default } from './BackgroundBannerImage';
